import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry } from '../../../lib/components';
import { dateFormat, ReactNodeGenerator } from '../../../lib/helpers';
import { routes } from '../../../pages/Routes';
import { ClassroomStatusLabels } from '../../classroom/models/classroom-models';
import { TeacherWorkDaySceneStore } from './TeacherWorkDaySceneStore';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import $ from 'jquery';
import { Disposers } from 'lib/helpers';
import { action, observable, reaction } from 'mobx';
import Swal from 'sweetalert2';
import moment from 'moment';

type ModalProps = {
  store: TeacherWorkDaySceneStore;
}

type ModalState = {
  isOpen: boolean;
  startTime: string;
  endTime: string;
  showDelete: boolean;
}

const defaultStartTime: string = "09:00";
const defaultEndTime: string = "18:00";

class RangeTimePickerModal extends React.Component<ModalProps, ModalState> {

  readonly store: TeacherWorkDaySceneStore;

  constructor(props: ModalProps) {
    super(props);
    this.store = this.props.store;
    this.state = {
      isOpen: false,
      startTime: defaultStartTime,
      endTime: defaultEndTime,
      showDelete: false,
    };
  }

  private startKendoTimePicker: kendo.ui.TimePicker | null = null;
  private endKendoTimePicker: kendo.ui.TimePicker | null = null;
  readonly disposers = new Disposers();

  componentDidMount() {
    const self = this;
    this.disposers.add(reaction(
      () => this.store.ModalOpenDayofweekWithIndex,
      (dayOfWeekWithIndex) => {
        if (!dayOfWeekWithIndex) {
          this.setState({ isOpen: false });
          return;
        }
        const parts = dayOfWeekWithIndex.split("-");
        if (parts.length != 2) {
          return;
        }
        const dayOfWeek = parts[0];
        const key = parts[1];
        const map = (this.store as any)[dayOfWeek] as Map<string, string>;
        const startEndParts = map.get(key)?.split("-");
        if (startEndParts?.length == 2) {
          const start = startEndParts[0];
          const end = startEndParts[1];
          this.setState({
            startTime: start,
            endTime: end,
            showDelete: true
          })

        }
        else {
          this.setState({
            startTime: defaultStartTime,
            endTime: defaultEndTime,
            showDelete: false
          })
        }

        this.setState({ isOpen: true });
      }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const store = this.store;

    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}
        onClosed={this.onClosed}>
        <ModalHeader>
          <div>Monday</div>
        </ModalHeader>
        <ModalBody>
          <h5>Start time</h5>
          <p>
            <input id="slotStart" />
          </p>
          <h5>End time</h5>
          <p>

            <input id="slotEnd" />
          </p>
        </ModalBody>
        <ModalFooter>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ textAlign: 'left' }}>
                {
                  this.state.showDelete &&
                  <button type="button" className="btn btn-link" style={{ color: '#9a9a9a' }}
                    onClick={this.onDeleteClick}>
                    Delete
                  </button>
                }
              </div>
              <div className='col' style={{ textAlign: 'right' }}>
                <button type="button" className="btn btn-light" style={{ marginRight: '5px' }}
                  onClick={this.onCloseClick}>
                  Close
                </button>
                <button type="button" className="btn btn-primary"
                  onClick={this.onSubmitClick}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {
    if (!this.store.ModalOpenDayofweekWithIndex) {
      return;
    }
    const self = this;
    const parts = this.store.ModalOpenDayofweekWithIndex?.split("-");
    if (parts.length != 2) {
      return;
    }

    function startChange(evt: kendo.ui.TimePickerChangeEvent) {
      const startPicker = evt.sender;
      if (!startPicker) {
        return;
      }
      var startTime = startPicker.value();
      if (!self.endKendoTimePicker) {
        return;
      }

      if (startTime) {
        startTime = new Date(startTime);
        self.endKendoTimePicker.min(startTime);
        startTime.setMinutes(startTime.getMinutes() + startPicker.options.interval!);
        self.endKendoTimePicker.value(startTime);
      }
    }

    self.startKendoTimePicker = $("#slotStart").kendoTimePicker({
      format: "HH:mm",
      change: function (evt) { startChange(evt) },
    }).data("kendoTimePicker");
    self.startKendoTimePicker.value(this.state.startTime);
    self.startKendoTimePicker.min("00:00");
    self.startKendoTimePicker.max("23:30");

    self.endKendoTimePicker = $("#slotEnd").kendoTimePicker({
      format: "HH:mm"
    }).data("kendoTimePicker");
    self.endKendoTimePicker.value(this.state.endTime);
    self.endKendoTimePicker.min("00:00");
    self.endKendoTimePicker.max("23:30");
  }

  onClosed = () => {
    this.startKendoTimePicker?.destroy();
    this.endKendoTimePicker?.destroy();
  }

  onCloseClick = () => {
    this.store.ModalOpenDayofweekWithIndex = null;
    this.setState({ isOpen: false });
  }

  onSubmitClick = async () => {
    var startDate = this.startKendoTimePicker?.value();
    var endDate = this.endKendoTimePicker?.value();
    if (!startDate) {
      Swal.fire({ icon: 'warning', text: 'Start time required' });
      return;
    }
    if (!endDate) {
      Swal.fire({ icon: 'warning', text: 'End time required' });
      return;
    }

    var startMoment = moment(startDate);
    var endMoment = moment(endDate);

    var startTimeStr = startMoment.format("HH:mm");
    var endTimeStr = endMoment.format("HH:mm");

    await this.store.SubmitSave(startTimeStr, endTimeStr);
    Swal.fire({ icon: 'success', text: 'Save success' })
  }

  onDeleteClick = async () => {
    await this.store.SubmitDelete();
  }
}

@observer
export class TeacherWorkDayScene extends React.Component {
  store: TeacherWorkDaySceneStore;

  constructor(props: any) {
    super(props);
    this.store = new TeacherWorkDaySceneStore();
  }

  componentDidMount() {
    this.store.load();
  }

  openModal = (dayOfWeek: string) => {
    this.store.ModalOpenDayofweekWithIndex = dayOfWeek;
  }

  render() {
    return Array.from(this.renderer());
  }

  * renderer(): ReactNodeGenerator {
    const store = this.store;
    if (store.workdayState === null) {
      return;
    }
    const state = store.workdayState;
    yield (<PromiseMessage key="loader-state"
      label="Loading work days" state={state} align="right" />);

    yield (<RangeTimePickerModal key="RangeTimePickerModal" store={store} />);

    if (!state.isResolved)
      return;

    const monday0Txt = store.Monday.get("0") || "Add";
    const monday1Txt = store.Monday.get("1") || (store.Monday.size == 1 && "Add") || null;
    const monday2Txt = store.Monday.get("2") || (store.Monday.size == 2 && "Add") || null;

    const tuesday0Txt = store.Tuesday.get("0") || "Add";
    const tuesday1Txt = store.Tuesday.get("1") || (store.Tuesday.size == 1 && "Add") || null;
    const tuesday2Txt = store.Tuesday.get("2") || (store.Tuesday.size == 2 && "Add") || null;

    const wednesday0txt = store.Wednesday.get("0") || "Add";
    const wednesday1txt = store.Wednesday.get("1") || (store.Wednesday.size == 1 && "Add") || null;
    const wednesday2txt = store.Wednesday.get("2") || (store.Wednesday.size == 2 && "Add") || null;

    const thursday0txt = store.Thursday.get("0") || "Add";
    const thursday1txt = store.Thursday.get("1") || (store.Thursday.size == 1 && "Add") || null;
    const thursday2txt = store.Thursday.get("2") || (store.Thursday.size == 2 && "Add") || null;

    const friday0txt = store.Friday.get("0") || "Add";
    const friday1txt = store.Friday.get("1") || (store.Friday.size == 1 && "Add") || null;
    const friday2txt = store.Friday.get("2") || (store.Friday.size == 2 && "Add") || null;

    const saturday0txt = store.Saturday.get("0") || "Add";
    const saturday1txt = store.Saturday.get("1") || (store.Saturday.size == 1 && "Add") || null;
    const saturday2txt = store.Saturday.get("2") || (store.Saturday.size == 2 && "Add") || null;

    const sunday0txt = store.Sunday.get("0") || "Add";
    const sunday1txt = store.Sunday.get("1") || (store.Sunday.size == 1 && "Add") || null;
    const sunday2txt = store.Sunday.get("2") || (store.Sunday.size == 2 && "Add") || null;

    yield (
      <div key="working-days">
        <div className="row">
          <h1>My working day time(Teacher)</h1>
        </div>
        <div className="row" key="schedule">
          <div className="col">
            <table className="table table-sm table-bordered table-hover">
              <tbody>
                <tr>
                  <td>Monday</td>
                  <td>
                    {
                      monday0Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Monday-0') }}>{monday0Txt}</button>
                    }
                    {
                      monday1Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Monday-1') }}>{monday1Txt}</button>
                    }
                    {
                      monday2Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Monday-2') }}>{monday2Txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Tuesday</td>
                  <td>
                    {
                      tuesday0Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Tuesday-0') }}>{tuesday0Txt}</button>
                    }
                    {
                      tuesday1Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Tuesday-1') }}>{tuesday1Txt}</button>
                    }
                    {
                      tuesday2Txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Tuesday-2') }}>{tuesday2Txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Wednesday</td>
                  <td>
                    {
                      wednesday0txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Wednesday-0') }}>{wednesday0txt}</button>
                    }
                    {
                      wednesday1txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Wednesday-1') }}>{wednesday1txt}</button>
                    }
                    {
                      wednesday2txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Wednesday-2') }}>{wednesday2txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Thursday</td>
                  <td>
                    {
                      thursday0txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Thursday-0') }}>{thursday0txt}</button>
                    }
                    {
                      thursday1txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Thursday-1') }}>{thursday1txt}</button>
                    }
                    {
                      thursday2txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Thursday-2') }}>{thursday2txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Friday</td>
                  <td>
                    {
                      friday0txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Friday-0') }}>{friday0txt}</button>
                    }
                    {
                      friday1txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Friday-1') }}>{friday1txt}</button>
                    }
                    {
                      friday2txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Friday-2') }}>{friday2txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Saturday</td>
                  <td>
                    {
                      saturday0txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Saturday-0') }}>{saturday0txt}</button>
                    }
                    {
                      saturday1txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Saturday-1') }}>{saturday1txt}</button>
                    }
                    {
                      saturday2txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Saturday-2') }}>{saturday2txt}</button>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Sunday</td>
                  <td>
                    {
                      sunday0txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Sunday-0') }}>{sunday0txt}</button>
                    }
                    {
                      sunday1txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Sunday-1') }}>{sunday1txt}</button>
                    }
                    {
                      sunday2txt &&
                      <button className='btn btn-secondary' style={{ marginRight: '5px', width: '150px' }} onClick={() => { this.openModal('Sunday-2') }}>{sunday2txt}</button>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>);
  }
}